<template lang="html">
    <gcmcn-layout
        title="ALL RECEIVERS"
        custom-class="event-view"
    >
        <el-button
            slot="action-btn"
            type="primary"
            class="gcmcn-primary-btn"
            @click="createIrd"
        >
            Add {{ activeName === 'ird' ? 'automatic receivers ' : 'manual receivers' }}
        </el-button>
        <el-row
            :gutter="26"
            class="gcmcn-separator"
            :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
        >
            <el-col
                :span="12"
            >
                <el-tabs
                    class="gcmcn-tabs"
                    style="margin-top: 30px; height: calc(100% - 30px)"
                    v-model="activeName"
                >
                    <el-tab-pane
                        v-if="userIsAtLeastAdmin || userIsEntityAdmin"
                        label="Automatic receiver"
                        name="ird"
                    >
                        <ird-list
                            :key="activeName"
                            :selected-ird-uid="selectedIrdUid"
                            @change-selected-ird="changeSelectedIrd"
                        ></ird-list>
                    </el-tab-pane>
                    <el-tab-pane label="Manual receiver" name="manual-receiver">
                        <manual-receiver-list
                            :key="activeName"
                            @change-selected-manual-receiver="changeselectedManualReceiver"
                        ></manual-receiver-list>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col
                :span="12"
                :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
                style="overflow: auto;"
            >
                <template v-if="activeName === 'ird'">
                    <ird-form
                        v-if="displayFormView"
                        :ird="selectedIrd"
                        @leave-form-view="leaveFormView"
                    ></ird-form>
                    <div v-else-if="selectedIrd">
                        <div class="page-title">Details</div>
                        <div class="universe-details-container gcmcn-card-gradient">
                            <ird-details
                                :ird="selectedIrd"
                                @edit-ird="displayFormView = true"
                                @on-automatic-receiver-deleted="selectedIrd = null"
                            ></ird-details>
                        </div>
                    </div>
                    <div v-else class="list-empty" style="margin-top: 40px;">Please select an automatic receiver</div>
                </template>
                <template v-else>
                    <div
                        v-if="displayFormView"
                        v-separator-link="200"
                    >
                        <manual-receiver-form

                            :manual-receiver="selectedManualReceiver"
                            :is-dashboard="true"
                            @leave-form-view="leaveFormView"
                        ></manual-receiver-form>
                    </div>
                    <div v-else-if="selectedManualReceiver">
                        <div class="page-title">Details</div>
                        <div class="universe-details-container gcmcn-card-gradient">
                            <manual-receiver-details
                                :manual-receiver="selectedManualReceiver"
                                @edit-manual-receiver="displayFormView = true"
                                @on-manual-receiver-deleted="selectedManualReceiver = null"
                            ></manual-receiver-details>
                        </div>
                    </div>
                    <div v-else class="list-empty" style="margin-top: 40px;">Please select a manual receiver</div>
                </template>
            </el-col>
        </el-row>
    </gcmcn-layout>
</template>

<script>

import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import IrdList from './Ird/irdList.vue';
import IrdDetails from './Ird/irdDetails.vue';
import IrdForm from './Ird/irdForm.vue';

import ManualReceiverList from './Manual/manualReceiverList.vue';
// import ManualReceiverForm from './Manual/manualReceiverForm.vue';
import ManualReceiverDetails from './Manual/manualReceiverDetails.vue';
import { mapGetters } from 'vuex';
import { ManualReceiverForm } from 'gcmcn-common';

export default {
    components: {
        GcmcnLayout,
        IrdList,
        IrdDetails,
        IrdForm,
        ManualReceiverList,
        ManualReceiverForm,
        ManualReceiverDetails,
    },
    data () {
        return {
            selectedIrd: null,
            selectedManualReceiver: null,
            displayFormView: false,
            activeName: this.userIsAtLeastAdmin ? 'ird' : 'manual-receiver',
        };
    },
    computed: {
        ...mapGetters([
            'irdsByUid',
            'manualReceiversByUid',
            'userIsAtLeastAdmin',
            'userIsEntityAdmin'
        ]),

        selectedIrdUid (){
            return this.selectedIrd ? this.selectedIrd.uid : '';
        }
    },

    watch: {
        activeName (){
            this.$set(this, 'selectedIrd',null);
            this.$set(this, 'selectedManualReceiver',null);
        },
    },
    mounted(){
        if(this.userIsEntityAdmin()){
            this.$set(this, 'activeName', 'ird');
        }
    },
    methods: {
        createIrd (){
            this.$set(this, 'selectedIrd',null);
            this.$set(this, 'selectedManualReceiver',null);
            this.displayFormView = true;
        },
        changeSelectedIrd (irdUid) {
            if(this.displayFormView) this.displayFormView = false;
            this.$set(this, 'selectedIrd', this.irdsByUid(irdUid));
        },
        changeselectedManualReceiver (mrUid) {
            if(this.displayFormView) this.displayFormView = false;
            this.$set(this, 'selectedManualReceiver', this.manualReceiversByUid(mrUid));
        },
        leaveFormView (refresh=false){
            this.displayFormView = false;
            if(refresh){
                this.$store.dispatch('fetchModelByName', 'manualReceivers');
            }
        },
    }
};
</script>

<style lang="scss">
.event-view {
}
</style>



// WEBPACK FOOTER //
// src/components/page/Receiver/index.vue